export const PortalParameters = {
    PortalUser: 'PortalUser',
    CurrentDateTime: 'CurrentDateTime'
};
